import { createTV } from "../../models/text-value.model";
import { createValidator } from "../text-field";

/**
 * @param {Object} $0 - Pass in Form Configuration Object. Destructured Documentation
 * @param {string?} $0.field_name - Field Name is the field Type of the form - Default Value = 'input'
 * @param {string} $0.required - Required fields will get a required validation inserted
 * @param {string} $0.unique - Unique field, Comes in handy to pass validators Argument based on this property
 * @param {string} $0.name - Name of the Field Property Key
 * @param {string} $0.text_key - Text Key ?
 * @param {string} $0.type - This is alternative Type of Field Name, no need to pass anything
 * @param {boolean} $0.showValidationIcons - Show Validatin Icons Props of the Text Field Component
 * @param {Array} $0.validators - Pass the validators directly into the TextField Compoennt
 */
export const createForm = ({
  field_name = 'input', // FIELD
  required = '',
  unique = '',
  name = '',
  text_key = '',
  text = '',
  type = '',
  field_type = '',
  showValidationIcons = false,
  validators = [],

  //Dropdown Props
  options = [],
} = {}) => {
  if (unique) {
    console.log({ " unique validators": validators, name });
  }
  return {
    field_name,
    required,
    unique,
    name,
    text_key,
    text,
    type,
    field_type,
    showValidationIcons,
    validators,

    // Dropdown Data
    options,
  }
};

export const createForms = (forms = []) => {
  return forms.map(createForm);
}

export const isTextField = (form = createForm()) => {
  return form.field_name === 'input' && form.type === 'text';
}
export const isDatePicker = (form = createForm()) => {
  return form.field_name === 'input' && form.type === 'date';
}
export const isDropdown = (form = createForm()) => {
  return form.field_type === 'list';
}
export const isCheckbox = (form = createForm()) => {
  return form.field_type === 'checkbox';
}

export const getControlType = (form = createForm()) => {
  if (isTextField(form)) {
    return 'textfield';
  }
  if (isDatePicker(form)) {
    return 'date';
  }
  if (isDropdown(form)) {
    return 'dropdown';
  } if (isCheckbox(form)) {
    return 'checkbox';
  }
  return 'textfield';
}
